import { envMap, COSMOS_USER_SESSION } from "./constants";

const urlObject = {
  [envMap.PRODUCTION]: {
    API_URL: "https://event-api.classplusapp.com",
  },
  [envMap.PROD]: {
    API_URL: "https://event-api.classplusapp.com",
  },
  [envMap.PREPROD]: {
    API_URL: "https://apip-preprod.classplusapp.com",
  },
  [envMap.STAGING]: {
    API_URL: "https://apip-staging.classplusapp.com",
  },
  [envMap.QA]: {
    API_URL: "https://apip-qa.classplusapp.com",
  },
};

export const getApiBaseURL = (env = envMap.STAGING) => {
    if (typeof env === "string" && urlObject[env?.toLowerCase()]) {
      return urlObject[env?.toLowerCase()].API_URL;
    }
    console.log(`cosmos - ${env} is not a valid environment, calling stag env`);
    return urlObject[envMap.STAGING].API_URL;
};

export const getLocalStorageKey = (subSourceId = "") => {
  let key = COSMOS_USER_SESSION;
  if (subSourceId) {
    key = `${COSMOS_USER_SESSION}_${subSourceId}`;
  }
  return key;
};
